<template>
    <VesselDetails/>
</template>

<script>
import VesselDetails from '../../components/vessels/VesselDetails';

export default {
  components: {
    VesselDetails,
  },
};
</script>
